
import Container from '@/components/container';
import Half from '@/components/layout/half';
import Button from '@/ui-kit/components/button';
import LazyImage from '@/components/lazy-image';
import ImageHelper from '@/utils/ImageHelper';
import WindowSize from '@/ui-kit/mixins/windowSize';
import { Comparator } from '@/ui-kit/enums';
import Typography from '@/ui-kit/components/typography';
import { TypographyType } from '@/ui-kit/components/typography/enums';

/**
 * @component Hero
 *
 * Hero component to be used in all pages
 *
 * @public
 */

export default {
  name: 'HeroComponent',
  components: {
    Container,
    Half,
    Button,
    LazyImage,
    Typography,
  },
  mixins: [WindowSize],
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      TypographyType,
    };
  },
  computed: {
    imageRatio() {
      return ImageHelper.constructor.getImageRatio(this.data.image.dimensions);
    },
    heroImageSizes() {
      return [
        {
          comparator: Comparator.Less,
          breakpoint: this.breakpoints.Medium,
          imageSize: 840,
        },
        {
          comparator: Comparator.Greater,
          breakpoint: this.breakpoints.Medium,
          imageSize: 600,
        },
      ];
    },
  },
};
